import centerIsClaimed from './centerIsClaimed'
import centerHasCertifications from './centerHasCertifications'
import { Center } from '@/types/models'

interface CenterIsClaimedAndVerified {
  (center: Center): boolean
}

const centerIsClaimedAndVerified: CenterIsClaimedAndVerified = (center) =>
  centerIsClaimed(center) && centerHasCertifications(center)

export default centerIsClaimedAndVerified
